import { SET_AUTHENTICATED_USER, RESET_AUTHENTICATED_USER } from "../actions";

const localStorageAuthObject = localStorage.getItem("hominem")
  ? JSON.parse(atob(localStorage.getItem("hominem")))
  : null;

export const INIT_STATE = localStorageAuthObject
  ? localStorageAuthObject
  : {
      FirstName: "",
      LastName: "",
      UserName: "",
      Password: "",
      Branch: "",
      Id: "",
      Role: "",
    };

export const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_AUTHENTICATED_USER:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_AUTHENTICATED_USER:
      return INIT_STATE;
    default:
  }
};
